import { z } from 'zod';

export const SharedSessionStatusSchema = z.enum(['scheduled', 'active', 'ended']);
export type SharedSessionStatus = z.infer<typeof SharedSessionStatusSchema>;

export const JoinSessionResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  device_uuid: z.string(),
  session_id: z.string(),
  status: SharedSessionStatusSchema,
  starts_at: z.string().optional(),
});
export type JoinSessionResponse = z.infer<typeof JoinSessionResponseSchema>;

export const RefreshTokenResponseSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});
export type RefreshTokenResponse = z.infer<typeof RefreshTokenResponseSchema>;

export interface SharedSessionGuestSession {
  device_uuid: string;
  session_id: string;
  starts_at?: string;
}

export const SHARED_SESSION_STORAGE_KEYS = {
  AUTH_MODE: 'auth_mode',
  ACCESS_TOKEN: 'shared_session_access_token',
  REFRESH_TOKEN: 'shared_session_refresh_token',
  DEVICE_UUID: 'shared_session_device_uuid',
  SESSION_ID: 'shared_session_id',
  STARTS_AT: 'shared_session_starts_at',
  JOIN_CODE: 'shared_session_join_code',
} as const;
